import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import {  validate, clean } from 'rut.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import {  NavLink } from "react-router-dom";

export default function Paso1(props) {
    const { register, handleSubmit , formState: { errors }} = useForm();
    const toastId = React.useRef(null);

    const [ spinner, setSpinner ] = useState(false);

    const onSubmit = async (data) => {
        setSpinner(true)
        const { rut, rut_dv } = data
        const rut_revisar = clean(rut+''+rut_dv)
        if(!validate(rut_revisar)) {
            if(! toast.isActive(toastId.current)) {
                toast.error('El rut ingresado no es válido', {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
            }
            setSpinner(false)

        } else { 
           
            window.grecaptcha.ready(async function() {
                window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY, {action: 'submit'}).then(async function(captchaToken) {
                    const localToken = localStorage.getItem('token')
        
                    const options = {
                        headers: {
                            'Content-Type': 'application/json',
                            'token': localToken,
                            'captchatoken': captchaToken
                        }
                    };
                    try {
                        const { data: data_resp } = await axios.post(process.env.REACT_APP_URL_API+process.env.REACT_APP_STEP1, JSON.stringify(data), options)
                        if(!data_resp.token){

                            if(! toast.isActive(toastId.current)) {
                                toast.error(data_resp.msg, {
                                    position: "top-center",
                                    autoClose: false,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    });
                            }
                        } else { 
                            localStorage.setItem('token', data_resp.token)
                            window.location.href = process.env.REACT_APP_URL
                            setSpinner(false)

                        }
                   
                    } catch(e){
                        console.log(e)
                    }
                    setSpinner(false)
                });
              });

        }
        
    }
   
    return (

      <form onSubmit={handleSubmit(onSubmit)}>
            <ToastContainer
            position="top-center"
            autoClose={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            />
         <div>
          <div className="proceso">
            <div className="line">
                <hr />
            </div>
            <div className="linea-pasos">
                <div className="center">
                    {/* <a class="paso-active" href="index.html">1</a> */}
                    <NavLink className="paso-active" activeClassName="paso-active" to="/">1</NavLink>
                    <p>DATOS PERSONALES</p>
                </div>
                <div className="center">
                    {/* <a class="paso" href="montos.html">2</a> */}
                    <NavLink className="paso" to="/">2</NavLink>
                    <p>MONTO Y PLAZO</p>
                </div>
                <div className="center">
                    {/* <a class="paso" href="simulacion.html">3</a> */}
                    <NavLink className="paso" to="/">3</NavLink>
                    <p>SIMULACIÓN</p>
                </div>
            </div>    
        </div>
      </div>       
        <div>
        {spinner &&  <div className="loading">
            <div className="uil-ring-css">
                <div></div>
            </div>
            </div>
        }
        <div className="campos"> 
                <div className="linea2">
                    <div className="container">
                        <p>Nombre</p>
                        <input className="box" type="text" name="nombres" {...register("nombres", { required: true  })} aria-invalid={errors.nombres ? "true" : "false"}  />
                        {errors.nombres && <div className="error-p">Obligatorio</div>}

                    </div>
                    <div className="container">
                        <p>Apellidos</p>
                        <input className="box" type="text" name="apellidos"  {...register("apellidos", { required: true })} aria-invalid={errors.apellidos ? "true" : "false"}  />
                        {errors.apellidos && <div className="error-p">Obligatorio</div>}

                    </div>
                    <div className="container">
                        <p>RUT</p>
                        <div className="rut">
                            <input className="box-rut" type="number" id="rut" maxLength="8" aria-invalid={errors.rut ? "true" : "false"} {...register("rut", { required: true , pattern: /^[0-9]+$/i})} />
                            <p >-</p>
                            <input className="box-rutdv" type="text" name="rut_dv" maxLength="1"  {...register("rut_dv", { required: true })} aria-invalid={errors.rut_dv ? "true" : "false"} />
                       
                        </div>
                        {(errors.rut || errors.rut_dv) && <div className="error-p">RUT Obligatorio</div>}
                        {(errors.rut_invalido) && <div className="error-p">RUT No válido</div>}

                    </div>
                </div>
                <div className="linea1">
                    <div className="container">
                        <p>E-Mail</p>
                        <input className="box" type="email" name="email" {...register("email", { required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, })} aria-invalid={errors.email ? "true" : "false"} /> 
                        {errors.email && <div className="error-p">E-mail inválido</div> }

                    </div>
                    <div className="container">
                        <p>Teléfono <small>(Ej. 912345678)</small></p>
                        <input className="box" type="tel" name="telefono" maxLength="9" {...register("telefono", { required: true, minLength: 6, maxLength:9,  pattern: /^[0-9]+$/i })} aria-invalid={errors.telefono ? "true" : "false"} />
                        {errors.telefono && <div className="error-p">Ingrese teléfono</div>}
                    </div>
                </div>
                <div className="boton">
                    <button type="submit" >CONTINUAR</button>
                </div>
            </div> 
        </div>
     </form>
    );
  }